import React from 'react';
import autoBind from 'react-autobind';
import Download from 'downloadjs';
import Validators from '../utils/Validators.js';
import Spinner from './Common/Spinner.jsx';
import InlineMessage from './Common/InlineMessage.jsx';

import AppConstants from '../constants/ApplicationConstants.js';
import DownloadConstants from '../constants/DownloadConstants.js';
import ApplicationActions from '../actions/ApplicationActions.js';
import ApplicationStore from '../stores/ApplicationStore';


let downloaded = false;
export default class DownloadMenu extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = {
            hideDownloadText: ApplicationStore.hideDownloadText()
        };
    }

    formToDownloadCheckbox(e) {
        var objectIndex = e.currentTarget.id;
        var links = objectIndex.split('-');
        var index = '';
        if (Validators.requiredValidation(links[1])) {
            index = links[1];
        }
        ApplicationActions.updateFormsToDownload({ index: index, checked: !this.props.formsToDownload[index].checked })
    }

    onCloseClick(){
        ApplicationActions.showDownloadMenu(false);
    }

    onDownloadClick(){
        ApplicationActions.prepareFormsToDownload();
        ApplicationActions.requestApplicationDownload();
    }

    componentWillUpdate(nextProps) {
        if (nextProps.selectedForms && nextProps.downloadFormApplication && nextProps.readyForDownload === true) {
            ApplicationActions.downloadForms(nextProps.selectedForms, this.props.productId, nextProps.downloadFormApplication);
        }
        if (nextProps.formDownloaded === true) {
            downloaded = false;
        }
        if (!downloaded && Validators.requiredValidation(nextProps.downloadedForms) && nextProps.downloadedForms.length>0 && nextProps.formDownloaded === false) {
            downloaded = true;
            let fileName = Validators.requiredValidation(window.NOA.configuration.documentFileName) ? window.NOA.configuration.documentFileName : DownloadConstants.DefaultFileName;
            Download(nextProps.downloadedForms, fileName, DownloadConstants.ZipContentType);
            setTimeout(function() {
                ApplicationActions.clearDownloadedForms();
            }, 1000);
        }
    }

    render() {
        let hideDownloadText = this.state.hideDownloadText;
        let formToDownloadCheckbox = this.formToDownloadCheckbox;
        let renderFormRow = function (data, index) {
            return <div key={index} id={'formToDownload-' + index} className="download-menu__checkbox">
                    <input id={'formToDownloadCheckbox-' + index}
                           name={'formToDownloadCheckbox-' + index}
                           type="checkbox"
                           checked={data.checked}
                           onChange={formToDownloadCheckbox} />
                    <span className="download-menu__checkbox-label">{data.name}</span>
                    <span hidden={hideDownloadText}><strong>{data.name_info}</strong></span>
                </div>;
        };

        let otherFormsLink = this.props.content && this.props.content.otherFormsLink ? this.props.content.otherFormsLink : null;
        let buttonStyle = this.props.enableDownloadButton ? 'btn btn-success btn-md' : 'btn btn-default btn-md';
        let disabled = !this.props.enableDownloadButton;
        return (
            <div className="container">
                { (this.props.showDownloadMenu)
                ? <div className="row download-menu">
                    <div className="col-xs-10">
                        <div className="download-menu__formlist">
                            {this.props.formsToDownload.map(function (data, index) {
                                return renderFormRow(data, index);
                            })}
                        </div>
                        <div className="download-menu__other-forms-link" dangerouslySetInnerHTML={{ __html: otherFormsLink }}></div>
                        {this.props.formsToDownload && this.props.formsToDownload.length > 0 
                        ? <div className="download-menu__buttons">
                            {this.props.downloadInProgress
                            ? <Spinner size={AppConstants.SpinnerSizes.Two} inline={true} customClass="download-menu__spinner" />
                            : <button type="button"
                                      className={buttonStyle}
                                      disabled={disabled}
                                      onClick={this.onDownloadClick}
                                      id="downloadMenuButton">
                                Download PDF Forms
                            </button>}
                        </div> 
                        : <div className="download-menu__no-buttons"></div> }
                        {this.props.downloadFormsFailed ? <InlineMessage id="downloadMenuError" type="errorNoLine" message={this.props.content.errorMessage}/> : null}
                    </div>
                    <div className="col-xs-2 text-right">
                        <a id="downloadMenuCloseIcon" className="user-notification-close" onClick={this.onCloseClick}>
                            <i className="icon icon-cancel-circled"></i>
                        </a>
                    </div>
                </div>
                : null }
            </div>
        );
    }
}

DownloadMenu.defaultProps = { downloadInProgress: false, enableDownloadButton: false };



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/DownloadMenu.jsx